// BARCINO - Suivi de commande — hors Barba (comme compte/commande).
// Le clic sur le bouton "submit" peut être intercepté par le handler de
// navigation global de Barba (tout clic hors lien reconnu est preventDefault,
// voir barcino_legal.js) : on prend donc la main nous-même sur la soumission
// au lieu de compter sur l'action par défaut du clic natif.
const barcinoSuivi = {
    init() {
        const form = document.querySelector('.bc-order-tracking__form');
        if (!form) return;

        const submitBtn = form.querySelector('button[type="submit"]');
        if (!submitBtn) return;

        submitBtn.addEventListener('click', (event) => {
            event.preventDefault();
            form.requestSubmit(submitBtn);
        });

        // Le résultat arrive via un rechargement complet (POST classique, pas d'AJAX) :
        // on scrolle jusqu'à lui s'il est présent au chargement de la page.
        // window.scrollTo (pas scrollIntoView, sans effet ici) — même pattern que
        // le scroll vers une catégorie dans barcino_faq.js.
        const result = document.querySelector('[data-suivi-result]');
        if (result) {
            window.setTimeout(() => {
                const top = result.getBoundingClientRect().top + window.pageYOffset - 32;
                window.scrollTo({ top, behavior: 'smooth' });
            }, 500);
        }
    },
};

export default barcinoSuivi;
